import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { LearningPathStatus } from 'enum/learningPathStatus.enum'
import {
  learningPathStateTranslationKey,
  learningPathStateVisuals,
} from './learningPathStateVisuals'
import { State } from './styled'

interface LearningPathStateBadgeProps {
  state: LearningPathStatus | number
}

export const LearningPathStateBadge = ({
  state,
}: LearningPathStateBadgeProps) => {
  const { t } = useTranslation()
  const numericState = Number(state) as LearningPathStatus
  const entry = learningPathStateVisuals.find(
    (item) => item.id === numericState
  )
  const translationKey = learningPathStateTranslationKey[numericState]

  if (!entry || !translationKey) {
    return <>--</>
  }

  return (
    <State color={entry.color} height={entry.height}>
      <FontAwesomeIcon icon={entry.icon} />
      {t(translationKey)}
    </State>
  )
}
